"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consoleWarn = exports.consoleLog = exports.consoleGroupEnd = exports.consoleGroupCollapsed = exports.consoleGroup = exports.consoleError = void 0;
/* eslint-disable no-console */

var consoleGroup = exports.consoleGroup = function consoleGroup(groupMessage) {
  try {
    console.group(groupMessage);
  } catch (e) {
    if (console) {
      console.log("--GROUP: ".concat(groupMessage, " --"));
    }
  }
};
var consoleGroupCollapsed = exports.consoleGroupCollapsed = function consoleGroupCollapsed(groupMessage) {
  try {
    console.groupCollapsed(groupMessage);
  } catch (e) {
    if (console && console.log) {
      console.log("--GROUP: ".concat(groupMessage, " --"));
    }
  }
};
var consoleGroupEnd = exports.consoleGroupEnd = function consoleGroupEnd() {
  try {
    console.groupEnd();
  } catch (e) {
    if (console) {
      console.log('--GROUP END--');
    }
  }
};
var output = function output(method, message) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (console) {
    if (data) {
      consoleGroupCollapsed(message);
    } else {
      console[method](message);
    }
    if (data) {
      console[method]('Data: ', data);
      if (data.stack) {
        console[method]('Stack trace: ', data.stack);
      }
    }
    if (data) {
      consoleGroupEnd();
    }
  }
};
var consoleError = exports.consoleError = output.bind(null, 'error');
var consoleWarn = exports.consoleWarn = output.bind(null, 'warn');
var consoleLog = exports.consoleLog = output.bind(null, 'log');